import { CodeHighlight } from '@ui/general';
import { CodeWithHighlights } from '@sonar-software/sonar-core';
import React from 'react';

export interface FormulaProps {
	formula: CodeWithHighlights | null;
}

export const Formula: React.FC<FormulaProps> = ({ formula }) => {
	if (!formula || !formula.code) {
		return null;
	}

	return <CodeHighlight
		code={ formula.code }
		codeReferences={ formula.codeReferences }
		index={ -1 }
		isNested />;
};
